import type { QsoType, PotaSpotType, SotaSpotType } from "@/types";
import type { ProfileInterface } from "@/interfaces";
import { BAND_RANGES } from "@/constants";

export function getProfileIntegrationStatus(profile: ProfileInterface): Record<string, boolean> {
  return {
    qrz: profile.qrz.isValid,
    hamQth: profile.hamQth.isValid,
  };
}
export function convertKhzToMhz(kHzValue: number) {
  return (kHzValue / 1000).toFixed(3);
}

export function findBandByFrequency(freqKHz: number): string | undefined {
  let low = 0;
  let high = BAND_RANGES.length - 1;

  while (low <= high) {
    const mid = Math.floor((low + high) / 2);
    const bandRange = BAND_RANGES[mid];

    if (bandRange.lower <= freqKHz && freqKHz <= bandRange.upper) {
      return bandRange.name;
    } else if (bandRange.lower > freqKHz) {
      high = mid - 1;
    } else {
      low = mid + 1;
    }
  }
  return undefined;
}

export function spotAlreadyInLog(spot: PotaSpotType | SotaSpotType, qsos: QsoType[]) {
  const spotDate = new Date(spot.spotTime).toISOString().slice(0, 10); // Extract YYYY-MM-DD from spotTime

  return qsos.some(
    (qso) =>
      qso.call === spot.activator &&
      (qso.band?.toLowerCase() || '') === (spot.band?.toLowerCase() || '') && // Safe comparison for band
      qso.mode === spot.mode &&
      (qso.potaRef === spot.reference || qso.sotaRef === spot.reference) && // Check both potaRef and sotaRef
      qso.qsoDate === spotDate // Compare based on the spot's date, not current date
  );
}